import { render, staticRenderFns } from "./UploadBom.vue?vue&type=template&id=85ded70c&"
import script from "./UploadBom.vue?vue&type=script&lang=ts&"
export * from "./UploadBom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports